import { useMemo } from 'react';
import { useModuleConfig } from './queries/admin/useModuleConfig';
import type { CatalogModuleConfig } from '../types/moduleConfig';

export interface CatalogLocationLabels {
  primaryLocationLabel: string;
  secondaryLocationLabel: string;
}

const FALLBACK: CatalogLocationLabels = {
  primaryLocationLabel: 'Primary Location',
  secondaryLocationLabel: 'Secondary Location',
};

/**
 * Provides configurable location field labels from module.catalog configuration.
 * Used in catalog forms, reports, and anywhere that displays
 * "Primary Location" / "Secondary Location" (or customer overrides).
 */
export function useCatalogLocationLabels(): CatalogLocationLabels {
  const { config } = useModuleConfig<CatalogModuleConfig>('catalog');
  const labels = config.features.location_labels;

  return useMemo<CatalogLocationLabels>(() => ({
    primaryLocationLabel: labels?.primary_location_label || FALLBACK.primaryLocationLabel,
    secondaryLocationLabel: labels?.secondary_location_label || FALLBACK.secondaryLocationLabel,
  }), [labels]);
}

/** Extract CatalogLocationLabels from a report-runner params bag. */
export function getCatalogLocationLabels(params: Record<string, unknown>): CatalogLocationLabels {
  return (params.catalogLocationLabels as CatalogLocationLabels | undefined) ?? FALLBACK;
}
